<template>
	<select
		:id="id"
		:value="modelValue"
		@change="optionSelected"
	>
		<slot></slot>
	</select>
</template>

<script>
export default {
	name: 'BaseSelect',
	props: {
		id: {
			type: String,
			required: true,
		},
		modelValue: {
			type: [String, Number],
			required: true,
		},
	},
	methods: {
		optionSelected(e) {
			this.$emit('update:modelValue', e.target.value);
		},
	},
};
</script>
